import React from "react";
import {Link} from "react-router-dom";
import {Map} from "immutable";
import Divider from "@material-ui/core/Divider";
import {AddBox as AddIcon, Edit as EditIcon} from "@material-ui/icons";
import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Tooltip from "@material-ui/core/Tooltip";
import FieldToggle from "../../components/FieldToggle";
import Button from "@material-ui/core/Button";
import MapMarker from "../../components/MapMarker";
import {Panel} from "../../components/Panel";
import style from "./style.js";

export const MarkerPanelMarkers = ({markerFilter, markers, floor, match}) => {
  // if markerId exists, it is the marker currently being edited
  // and should not be present in these MapMarkers
  const filteredMarkers = match.params.markerId
    ? markers.filter(marker => marker._id !== match.params.markerId)
    : markers;
  return filteredMarkers.map(marker =>
    markerFilter.get(marker._id) ? <MapMarker marker={marker} floor={floor} key={marker._id} /> : null
  );
};

export class MarkerPanel extends React.Component {
  renderMarkerList(markers, markerId, baseURL) {
    const {toggleMarkerFilter, markerFilter, disabled} = this.props;

    return markers.map((marker, index) => {
      const isEditing = markerId && markerId === marker._id;
      const isSelected = isEditing ? true : markerFilter.get(marker._id);
      const markerType = marker.type();
      return (
        <div key={marker._id} style={isEditing ? style.currentMarker : {}}>
          <ListItem>
            <ListItemIcon>
              <img className="listItemIcon" src={markerType.image.path} alt={markerType.name} />
            </ListItemIcon>
            <ListItemText primary={marker.name} secondary={markerType.name} />
            <ListItemIcon>
              <React.Fragment>
                <Link className="icon" to={`${baseURL}/${marker._id}`}>
                  <Tooltip title="Edit Marker" placement="top">
                    <IconButton disabled={isEditing || disabled}>
                      <EditIcon style={{color: "#999"}} />
                    </IconButton>
                  </Tooltip>
                </Link>
                <FieldToggle
                  value={isSelected}
                  // Disable currently editing marker
                  disabled={isEditing || disabled}
                  onChange={() => toggleMarkerFilter(marker._id)}
                />
              </React.Fragment>
            </ListItemIcon>
          </ListItem>
          <Divider />
        </div>
      );
    });
  }
  render() {
    const {floor, toggleAllMarkerFilter, markerFilter, match, disabled} = this.props;
    const {facilityId, buildingId, floorId, markerId} = match.params;
    const markers = floor.markers();
    const allToggled = markerFilter.size === markers.size;
    const baseURL = `/facilities/${facilityId}/buildings/${buildingId}/floors/${floorId}/markers`;

    return (
      <div>
        <Panel>
          <Grid container style={{marginBottom: "1em"}}>
            <Grid item xs={12} sm={6} style={{marginTop: ".5em"}}>
              <p className="text-muted">{`${markers.size} markers on ${floor.name}`}</p>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Link to={baseURL}>
                <Button color="primary" fullWidth disabled={disabled}>
                  <AddIcon className="buttonIconLeft" />
                  New Marker
                </Button>
              </Link>
            </Grid>
          </Grid>
          {!!markers.size && (
            <React.Fragment>
              <FieldToggle
                value={allToggled}
                label="Toggle All"
                labelPlacement="start"
                onChange={toggleAllMarkerFilter}
                disabled={disabled}
              />
              <List style={style.markerList}>{this.renderMarkerList(markers, markerId, baseURL)}</List>
            </React.Fragment>
          )}
        </Panel>
      </div>
    );
  }
}

export const withMarkerPanel = Component => {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        markerFilter: new Map()
      };
    }

    toggleMarkerFilter = markerId => {
      const {markerFilter} = this.state;
      const newMarkerFilter = markerFilter.get(markerId)
        ? markerFilter.delete(markerId)
        : markerFilter.set(markerId, true);
      this.setState({markerFilter: newMarkerFilter});
    };

    toggleAllMarkerFilter = () => {
      const {markerFilter} = this.state;
      this.setState({
        markerFilter: markerFilter.size
          ? new Map()
          : new Map(this.props.floor.markers().map(marker => [marker._id, true]))
      });
    };

    render() {
      return (
        <Component
          {...this.props}
          markerFilter={this.state.markerFilter}
          toggleMarkerFilter={this.toggleMarkerFilter}
          toggleAllMarkerFilter={this.toggleAllMarkerFilter}
        />
      );
    }
  };
};



// WEBPACK FOOTER //
// ./src/components/MarkerPanel/index.jsx